import api from '../../services/api';

const urlBase = '/usuarios';

export default {

  listar: (params = {}) =>
    api.get(urlBase, { params }),

  criar: data =>
    api.post(urlBase, data),

  atualizar: (usuario_id, data) =>
    api.put(`${urlBase}/${usuario_id}`, data),

  mudarStatus: usuario_id =>
    api.put(`${urlBase}/mudar-status/${usuario_id}`),

};